import { createContext, useContext, useEffect, useState } from "react";
import { detectCountry, getCachedCountry, setCountry as saveCountry } from "@/lib/geo";

const CountryContext = createContext(null);

export const CountryProvider = ({ children }) => {
    const [country, setCountryState] = useState(getCachedCountry());

    useEffect(() => {
        let cancelled = false;
        detectCountry().then((c) => {
            if (!cancelled && c) setCountryState(c);
        });
        return () => {
            cancelled = true;
        };
    }, []);

    const setCountry = (c) => {
        const saved = saveCountry(c);
        if (saved) setCountryState(saved);
    };

    return (
        <CountryContext.Provider value={{ country, setCountry }}>
            {children}
        </CountryContext.Provider>
    );
};

export const useCountry = () => {
    const ctx = useContext(CountryContext);
    if (!ctx) throw new Error("useCountry must be used within CountryProvider");
    return ctx;
};
